import React, { useState } from "react";

const PumpVariableSpeedSliderModal = ({
    onClose,
    pumpName,
    pumpNumber,
    pumpStatus,
    pumpSpeed,
    pumpVariableSpeed,
    sendPumpCommand
}) => {
    console.log(pumpVariableSpeed);
    const [speed, setSpeed] = useState(pumpVariableSpeed);
    

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999,
            }}
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "320px",
                    backgroundColor: "#1E1E1E",
                    borderRadius: "16px",
                    padding: "24px",
                    boxShadow: "0 0 20px rgba(0,0,0,0.7)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    animation: "fadeIn 0.2s ease-out",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        marginBottom: "20px",
                        position: "relative",
                    }}
                >
                    <span
                        onClick={onClose}
                        style={{
                            position: "absolute",
                            right: "0",
                            fontSize: "24px",
                            color: "white",
                            cursor: "pointer",
                            userSelect: "none",
                        }}
                    >
                        ×
                    </span>

                    <span
                        style={{
                            fontSize: "22px",
                            color: "white",
                            textAlign: "center",
                        }}
                    >
                        {pumpName}
                    </span>
                </div>

                <div
                    style={{
                        color: "white",
                        fontSize: "20px",
                        fontWeight: "bold",
                        marginTop: "8px",
                        marginBottom: "16px",
                    }}
                >
                    {speed}%
                </div>

                <input
                    type="range"
                    min="0"
                    max="100"
                    step="20"
                    value={speed}
                    onChange={(e) => {
                        let val = Number(e.target.value);
                        if (val < 20) val = 20;
                        setSpeed(val);
                    }}
                    style={{
                        width: "100%",
                        margin: "10px 0 30px 0",
                        WebkitAppearance: "none",
                        appearance: "none",
                        height: "10px",
                        borderRadius: "8px",
                        borderColor: "#00aaff",
                        background: `linear-gradient(to right, #00aaff ${speed}%, #2f3338 ${speed}%)`,
                        outline: "none",
                        cursor: "pointer",
                        transition: "background 0.3s ease",
                    }}
                />

                <button
                    style={{
                        width: "200px",
                        height: "50px",
                        background: "linear-gradient(90deg, #0099ff, #0066ff)",
                        border: "none",
                        borderRadius: "30px",
                        color: "white",
                        fontSize: "20px",
                        cursor: "pointer",
                        boxShadow: "0 0 20px rgba(0, 102, 255, 0.5)",
                        textTransform: "none",
                    }}
                    onClick={() => {
                        sendPumpCommand(pumpNumber, "vari", speed);
                        onClose();
                    }}
                >
                    Apply
                </button>

                <style>
                    {`
                        @keyframes fadeIn {
                            from { opacity: 0; transform: scale(0.95); }
                            to { opacity: 1; transform: scale(1); }
                        }

                        input[type="range"]::-webkit-slider-thumb {
                            -webkit-appearance: none;
                            appearance: none;
                            width: 22px;
                            height: 22px;
                            border-radius: 50%;
                            background: white;
                            border: 2px solid #0077ff;
                            cursor: pointer;
                            box-shadow: 0 0 10px rgba(0, 102, 255, 0.8);
                        }

                        input[type="range"]::-moz-range-thumb {
                            width: 22px;
                            height: 22px;
                            border-radius: 50%;
                            background: white;
                            border: 2px solid #0077ff;
                            cursor: pointer;
                            box-shadow: 0 0 10px rgba(0, 102, 255, 0.8);
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default PumpVariableSpeedSliderModal;
